<template>
  <div class="download container" v-wechat-title="'APP下载'">
    <!-- 提示信息 -->
    <div class="tips" v-show="tipsIsShow">
      点击右上角···按钮，然后在弹出的菜单中，点击“在浏览器打开”，即可安装
    </div>
    <!-- 测试用-浏览器信息 -->
    <div v-if="false">
      <div>system：{{systemFlag}}</div>
      <div>os：{{os}}</div>
      <div>ua：{{ua}}</div>
    </div>
    <!-- 正文 -->
    <div class="page">
      <!-- logo -->
      <img :src="logo" alt="" />
      <!-- app名称 -->
      <h3>
        <img :src="icon" alt="" />&nbsp;&nbsp;<span>{{ pageTitle }}</span>
      </h3>
      <!-- 下载：微信小程序使用 os==='weixin_xcx' -->
      <div v-show="os==='weixin_xcx'">
        <div class="copy">
          <div class="word left">
            <span>①.点击下方按钮复制URL</span>
            <span>②.打开手机浏览器</span>
            <span>③.在浏览器中黏贴此URL并访问</span>
            <span>④.在打开的新页面中点击”下载“</span>
          </div>
          <div class="btn" v-clipboard:copy="downloadUrl" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">
            <span>点击此处复制URL</span>
          </div>
        </div>
      </div>
      <!-- 下载：其它使用 -->
      <div v-show="os!=='weixin_xcx'">
        <div class="content" v-for="(item, index) in downloadList" :key="index">
          <div>
            <span>{{ item.type }}</span>
            &nbsp;<span>{{ item.tag }}</span>
          </div>
          <div>
            版本：<span>{{ item.version }}</span>
          </div>
          <div>
            大小：<span>{{ item.size }}</span>
          </div>
          <div>
            更新时间：<span>{{ item.date }}</span>
          </div>
          <div>
            <a :href="item.url" target="_blank" @click="handleDownloadClick">下载</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* global
PUBLIC_DOWNLOAD_TITLE,
PUBLIC_DOWNLOAD_LOGO,
PUBLIC_SYSTEM_FLAG,
PUBLIC_PRODUCT,
android_download_url,
ios_download_url
*/

import { CusToast } from '@/utils/CustomToast';

export default {
  name: 'Download',
  data() {
    return {
      pageTitle: PUBLIC_DOWNLOAD_TITLE,
      logo: require('@/assets/' + PUBLIC_DOWNLOAD_LOGO),
      systemFlag: PUBLIC_SYSTEM_FLAG,
      icon: null,
      downloadList: [],
      tipsIsShow: false,
      ua: '',
      os: '',
    };
  },
  mounted() {
    if (this.systemFlag === 'android') this.icon = require('@/assets/android_icon.png');
    else if (this.systemFlag === 'ios') this.icon = require('@/assets/ios_icon.png');
    else this.icon = require('@/assets/android_icon.png');

    this.ua = navigator.userAgent.toLowerCase();
    if (String(this.ua.match(/micromessenger/i)) === 'micromessenger') this.os = 'weixin';
    if (String(this.ua.match(/mqqbrowser/i)) === 'mqqbrowser' && String(this.ua.match(/tbs/i)) === 'tbs') this.os = 'qq';
    if (String(this.ua.match(/miniprogram/i)) === 'miniprogram') this.os = 'weixin_xcx';

    if (this.systemFlag === 'android' || this.systemFlag === '') {
      if (this.os === 'weixin' || this.os === 'qq') this.tipsIsShow = true;
      else this.tipsIsShow = false;
    }

    this.initData();
  },
  computed: {
    downloadUrl() {
      return window.location.href;
    },
  },
  methods: {
    initData() {
      const key = PUBLIC_PRODUCT.toLowerCase().trim();
      if (this.systemFlag === 'android') this.downloadList = android_download_url[key];
      else if (this.systemFlag === 'ios') this.downloadList = ios_download_url[key];
      else this.downloadList = android_download_url[key];
    },
    handleDownloadClick(e) {
      switch (this.os) {
        case 'weixin':
        case 'qq':
          if (this.systemFlag === 'android' || this.systemFlag === '') {
            alert('点击右上角···按钮，然后在弹出的菜单中，点击“在浏览器打开”，即可安装');
            e.preventDefault();
          }
          break;
        default:
          this.initData();
          break;
      }
    },
    onCopySuccess() {
      CusToast('复制成功');
    },
    onCopyError() {
      CusToast('复制失败');
    },
  },
};
</script>
